import React from "react";
import { ToastContainer } from "react-toastify";
import ReArrangeBrand from "../../components/ProductManager/Brand/ReArrangeBrand";

export const ReArrangeBrandPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ReArrangeBrand />
        </div>
      </div>
    </div>
  );
};
